import { css } from '@emotion/react'
import { useUser } from '../../../../../contexts/AuthContext'
import { isLatestEnterpriseOrTrial } from '@/lib/user'
import {
  ColumnName,
  COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS,
} from '../../reducers/column'
import { ResultTableProps } from '../result-table'
import { Header } from './Header'
import { HelpHeader } from './HelpHeader'
import { SortableHeader } from './SortableHeader'
import { font } from 'plume-ui'

export const TableHeader: React.FC<ResultTableProps & { name: ColumnName }> = ({
  name,
  ...rest
}) => {
  const style = {
    width: COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].width,
  }
  const user = useUser()

  switch (name) {
    case 'established':
    case 'ipoed':
    case 'employees':
    case 'lastFundraised':
    case 'updated':
    case 'created':
      return (
        <SortableHeader name={name} style={style} {...rest}>
          {COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
        </SortableHeader>
      )
    case 'totalFunding':
    case 'valuation':
      return (
        <SortableHeader name={name} style={style} {...rest}>
          <div
            css={css`
              width: 80%;
              text-align: center;
            `}
          >
            {COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
            <div
              className="sub-text"
              css={css`
                font-size: 11px;
                font-weight: ${font.weight.normal};
              `}
            >
              （百万円）
            </div>
          </div>
        </SortableHeader>
      )
    case 'ipoCategory':
      return (
        <HelpHeader
          label={COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
          helpText="日本国内スタートアップにおけるIPO企業の株主、上場市場による分類"
          style={style}
        />
      )
    case 'ipoJikasougaku':
      return (
        <Header style={style}>
          <div
            css={css`
              width: 80%;
              text-align: center;
            `}
          >
            {COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
            <div
              className="sub-text"
              css={css`
                font-size: 11px;
                font-weight: ${font.weight.normal};
              `}
            >
              （百万円）
            </div>
          </div>
        </Header>
      )
    case 'market':
      return (
        <HelpHeader
          label={COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
          helpText="日本国内スタートアップにおけるIPO時の上場市場"
          style={style}
        />
      )
    case 'latestInitialSeries':
      return (
        <HelpHeader
          label={COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
          helpText="スピーダが独自に定義する成長フェーズ"
          style={style}
          link={process.env.INITIAL_SERIES_HELP_ENDPOINT}
        />
      )
    case 'cbLatestRoundType':
      return (
        <HelpHeader
          label={COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
          helpText="定義を見る"
          style={style}
          link="https://help.initial.inc/ja/articles/5489432"
        />
      )
    case 'corporateNumber':
      return (
        <HelpHeader
          label={COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
          helpText="日本の国税庁が法人に対して発行した識別番号"
          style={style}
        />
      )
    case 'investingStatus':
    case 'contactPerson':
    case 'investingStatusUpdated':
    case 'memo':
      return isLatestEnterpriseOrTrial(user) ? (
        <Header style={style}>
          {COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
        </Header>
      ) : null
    case 'firstInterviewDate':
      return (
        <SortableHeader name={name} style={style} {...rest}>
          {COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
        </SortableHeader>
      )
    case 'sourcingRoute':
    case 'myLabels':
      return (
        <Header style={style}>
          {COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
        </Header>
      )
    case 'researchStatus':
      return (
        <HelpHeader
          label={COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
          helpText="日本国内スタートアップにおける調査状況"
          style={style}
        />
      )
    default:
      return (
        <Header style={style}>
          {COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS[name].label}
        </Header>
      )
  }
}
